import css from 'styled-jsx/css';

export default css`.placeItem {
  display: flex;
  flex-direction: row;
  padding: 10px;
  background-color: #fff;
  margin-top: 8px; }
  .placeItem .placeItem__thumbOuter {
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    position: relative; }
    .placeItem .placeItem__thumbOuter :global(.placeItem__thumb) {
      border-radius: 4px;
      width: 100px;
      height: 100px;
      object-fit: cover;
      overflow: hidden; }
    .placeItem .placeItem__thumbOuter .badgeCoupon {
      font-size: 12px;
      background-image: linear-gradient(0deg, #7d7af4dd, #838effdd);
      float: left;
      position: absolute;
      transform: rotate(-45deg);
      left: -60px;
      top: 8px;
      text-align: center;
      width: 150px;
      margin: 0;
      z-index: 1;
      color: #fff;
      font-weight: 700;
      line-height: 16px; }
  .placeItem .placeItem__info {
    position: relative;
    margin-top: 1px;
    flex: 1;
    margin-left: 10px; }
    .placeItem .placeItem__info .placeItem__titleOuter {
      cursor: pointer;
      color: #414141;
      padding-top: 3px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center; }
      .placeItem .placeItem__info .placeItem__titleOuter :global(.placeItem__clap) {
        flex-shrink: 0; }
      .placeItem .placeItem__info .placeItem__titleOuter a {
        color: #414141; }
      .placeItem .placeItem__info .placeItem__titleOuter .placeItem__title {
        font-size: 16px;
        padding-right: 8px;
        overflow: hidden; }
        .placeItem .placeItem__info .placeItem__titleOuter .placeItem__title :global(a) {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; }
        .placeItem .placeItem__info .placeItem__titleOuter .placeItem__title :global(.placeItem__text) {
          height: 16px; }
      .placeItem .placeItem__info .placeItem__titleOuter .placeItem__actionOuter {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center; }
        .placeItem .placeItem__info .placeItem__titleOuter .placeItem__actionOuter :global(.placeItem__action) {
          margin-right: -10px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          color: #fff;
          width: 50px;
          height: 20px; }
          .placeItem .placeItem__info .placeItem__titleOuter .placeItem__actionOuter :global(.placeItem__action) :global(.placeItem__text) {
            font-size: 12.5px;
            font-weight: 600;
            -webkit-transform-origin-x: 0;
            -webkit-transform: scale(0.9); }
      .placeItem .placeItem__info .placeItem__titleOuter :global(.placeItem__action--new) {
        background-color: rgba(208, 170, 255, 0.8); }
      .placeItem .placeItem__info .placeItem__titleOuter :global(.placeItem__action--hot) {
        background-color: rgba(218, 59, 60, 0.8); }
      .placeItem .placeItem__info .placeItem__titleOuter :global(.placeItem__action--more) {
        background-color: rgba(0, 0, 0, 0.8); }
      .placeItem .placeItem__info .placeItem__titleOuter :global(.placeItem__action--coupon) {
        background-image: linear-gradient(0deg, #7d7af4, #838eff); }
      .placeItem .placeItem__info .placeItem__titleOuter .placeItem__clap {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        color: #7d7af4;
        margin-right: 8px; }
        .placeItem .placeItem__info .placeItem__titleOuter .placeItem__clap img {
          width: 16px;
          height: 16px;
          margin-right: 3px; }
        .placeItem .placeItem__info .placeItem__titleOuter .placeItem__clap span {
          font-size: 12px; }
    .placeItem .placeItem__info .placeItem__priceOuter {
      color: #414141;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 12px;
      font-size: 12.5px; }
    .placeItem .placeItem__info .placeItem__openHours {
      color: #616161;
      font-size: 12px;
      margin-top: 8px;
      line-height: 19px; }
      .placeItem .placeItem__info .placeItem__openHours .placeItem__openStatus {
        color: #62d167; }
      .placeItem .placeItem__info .placeItem__openHours .placeItem__closeStatus {
        color: #ff8383; }
      .placeItem .placeItem__info .placeItem__openHours .placeItem__openText {
        font-size: 12px; }
    .placeItem .placeItem__info .placeItem__distance {
      color: #616161;
      font-size: 12px;
      margin-top: 8px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center; }
      .placeItem .placeItem__info .placeItem__distance .placeItem__starOuter {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex: 1; }
        .placeItem .placeItem__info .placeItem__distance .placeItem__starOuter .placeItem_btnStar {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 50px;
          margin-right: -10px;
          padding-top: 3px;
          padding-bottom: 3px; }
          .placeItem .placeItem__info .placeItem__distance .placeItem__starOuter .placeItem_btnStar :global(.iconStar) {
            width: 18px;
            height: 18px;
            color: #ffd052; }
      .placeItem .placeItem__info .placeItem__distance :global(.iconEye) {
        margin-right: 3px;
        color: #666; }
  .placeItem :global(.favoriteButton) {
    flex: none;
    padding: 16px 8px 16px 16px;
    bottom: -4px;
    right: -4px; }
    .placeItem :global(.favoriteButton) :global(.favoriteButton__text) {
      display: none; }
    .placeItem :global(.favoriteButton) :global(.favoriteButton__num) {
      display: none; }
`